import { jsx as _jsx } from "react/jsx-runtime";
import { HealthCheckTabContent } from './health-check-tab-content';
import { Tabs } from '@purpurds/purpur/tabs';
import styled from 'styled-components';
import { spacing } from 'theme/spacing';
const StyledTabs = styled(Tabs) `
  width: 100%;
  max-width: 750px;
  height: 100%;
  padding: ${spacing.spacing16} 0;
`;
export const HealthCheckTabs = ({ categories }) => (_jsx(StyledTabs, { variant: "contained", fullWidth: true, children: categories.map((category, index) => (_jsx(Tabs.Content, { name: category.name, tabId: `tab-${index + 1}`, children: _jsx(HealthCheckTabContent, { categoryValues: category.mainCategoryValues }) }, category.name))) }));
